export default __webpack_public_path__ + "static/media/corporate_events.90c16a23.svg";